module.exports = __webpack_public_path__ + "img/Scratches.1b130d02.png";